import { render } from "./Tal_searchResult.vue?vue&type=template&id=f1bf6f0a&scoped=true"
import script from "./Tal_searchResult.vue?vue&type=script&lang=js"
export * from "./Tal_searchResult.vue?vue&type=script&lang=js"

import "./Tal_searchResult.vue?vue&type=style&index=0&id=f1bf6f0a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\SAEUM\\Desktop\\teampl-project\\github\\unibuzzy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f1bf6f0a"]])

export default __exports__